import dayjs, { Dayjs } from 'dayjs';
import { z } from 'zod';

export const TicketPoolValidatorSchema = z.object({
  name: z.string(),
  expirationDate: z.string(),
  ticketPdf: z.string().optional(),
  ticketPoolUploadFormat: z.enum(['UNIQUE', 'IDENTICAL']),
});

export type TicketPoolValidator = z.infer<typeof TicketPoolValidatorSchema>;

export const TicketPoolFormValidatorSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'validation_name_required')
    .min(2, 'validation_name_min_length')
    .max(100, 'validation_name_max_length'),
  expirationDate: z
    .instanceof(dayjs as unknown as typeof Dayjs, {
      message: 'validation_expiration_date_required',
    })
    .refine((date) => !date.endOf('day').isBefore(dayjs()), {
      message: 'validation_expiration_date_future',
    }),
  ticketPdf: z
    .any()
    .refine((value) => value && value.originFileObj, 'validation_file_required')
    .refine((value) => {
      if (!value || !value.originFileObj) return false;
      const file = value.originFileObj;
      return file.type === 'application/pdf';
    }, 'validation_file_pdf_only')
    .refine((value) => {
      if (!value || !value.originFileObj) return false;
      const file = value.originFileObj;
      const maxSize = 100 * 1024 * 1024; // 100MB
      return file.size <= maxSize;
    }, 'validation_file_size_limit'),
  ticketPoolUploadFormat: z.enum(['UNIQUE', 'IDENTICAL'], {
    message: 'validation_upload_format_required',
  }),
});

export const UpdateTicketPoolFormValidatorSchema = z.object({
  name: z.string(),
  expirationDate: z.instanceof(dayjs as unknown as typeof Dayjs, {
    message: 'Expiration date was not configured',
  }),
});

export type UpdateTicketPoolFormValidator = z.infer<
  typeof UpdateTicketPoolFormValidatorSchema
>;

export type TicketPoolFormValidator = z.infer<
  typeof TicketPoolFormValidatorSchema
>;
